import React, { useContext } from 'react'
import { ViewTabs } from '@/components/ui/tabs'
import { Language } from 'api/Clients/Types/Language'
import { TickmillCompanyDto } from 'api/Identity/Types/Company'
import { DateFormatType } from 'api/Identity/Types/DateFormatType'
import { DepartmentDto } from 'api/Identity/Types/DepartmentDto'
import { RoleDto } from 'api/Identity/Types/Role'
import { TeamDto } from 'api/Identity/Types/Team'
import { UserResponse } from 'api/Identity/Types/UserResponse'
import { FormSubmitValues } from 'utils/formValidation'

import { PermissionsEnum } from '../../../api/Identity/Types/PermissionsEnum'
import { AuthSessionContext } from '../../../utils/AuthContext'
import { hasPermission } from '../../../utils/permissionsValidator'
import { AddEditUserForm, AddEditUserFormValues } from './AddEditUserForm'
import { AddEditUserStatisticsPage } from './AddEditUserStatisticsPage'

enum Tab {
  Details = 'details',
  Statistics = 'statistics',
}

interface OuterProps {
  values?: AddEditUserFormValues
  user?: UserResponse
  teams: TeamDto[]
  languages: Language[]
  roles: RoleDto[]
  dateFormat: DateFormatType[]
  departments: DepartmentDto[]
  tickmillCompanies: TickmillCompanyDto[]

  // setTeams(teams: AddEditUserTeamValues[]): void
  // openAdministrationUserTeamModal(): void
  onSubmit(values: FormSubmitValues<AddEditUserFormValues>): Promise<void>
}

export const AddEditUserTabs: React.FC<OuterProps> = (props) => {
  const [auth] = useContext(AuthSessionContext)
  const permissions = auth?.permissions || []
  const tabs = [
    {
      key: Tab.Details,
      translateKey: <span>Details</span>,
      visible: true,
      component: <AddEditUserForm {...props} />,
    },
  ]
  if (props.user) {
    tabs.push({
      key: Tab.Statistics,
      translateKey: <span>Statistics</span>,
      visible: hasPermission(permissions, PermissionsEnum.CanViewUserStatistics),
      component: <AddEditUserStatisticsPage user={props.user} />,
    })
  }
  return (
    <ViewTabs
      defaultKey={Tab.Details}
      tabs={tabs}
      permissions={permissions}
      hasPermission={hasPermission}
    />
  )
}
